import { useRef } from 'react';
import CheckIc from '../../assets/image/ic_check_on.svg';
import UncheckIc from '../../assets/image/ic_check_off.svg';

interface CheckBoxProps {
  id?: any;
  value: any;
  isChecked: boolean;
  onChange: (checked: boolean, id: any) => void;
  label?: string | null;
  checkStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  boxStyle?: React.CSSProperties;
  checkedIcon?: string;
  uncheckedIcon?: string;
  disabled?: boolean;
}

export default function CheckBox({
  id = null,
  value,
  isChecked,
  onChange,
  label = null,
  checkStyle = {},
  labelStyle = {},
  boxStyle = {},
  checkedIcon = CheckIc,
  uncheckedIcon = UncheckIc,
  disabled = false,
}: CheckBoxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="text-ellipsis overflow-hidden flex" style={boxStyle}>
      <button
        type="button"
        className="cursor-pointer"
        onClick={() => inputRef.current?.click()}
        style={{ verticalAlign: 'middle' }}
        disabled={disabled}
      >
        <img
          src={isChecked ? checkedIcon : uncheckedIcon}
          alt="check"
          style={{
            marginRight: '10px',
            width: '18px',
            height: '18px',
            ...checkStyle,
          }}
        />
        <input
          ref={inputRef}
          type="checkbox"
          id={id}
          value={value}
          checked={isChecked}
          onChange={(e) => onChange(e.target.checked, id)}
          style={{ display: 'none' }}
        />
      </button>
      {label && (
        <div
          className="truncate text-[14px] text-[#303133] font-[400] overflow-hidden whitespace-nowrap"
          style={{
            ...labelStyle,
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}
